import FileuploaderController from "../controllers/fileuploader_controller";

export default class extends FileuploaderController {
    get base_url() {

        return "/machine/image/fileuploader/"
    }
}
